<div class="modal fade" #modal tabindex="-1" role="dialog" aria-hidden="true">
    
    <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable" role="document">
      <div class="modal-content" *ngIf="detailFile">
          <div class="modal-header">
            <a href="" role="button" class="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </a>
          </div>
        <div class="modal-body pd-x-25 pd-sm-x-30 pd-t-40 pd-sm-t-20 pd-b-15 pd-sm-b-20">
          
          <div>
            <div class="row align-items-center mb-3" >
              <div class="col-md-5">
                <p class="no-padding no-margin"><strong>Nombre:</strong> {{detailFile.nombre_audio }}</p>
                <p class="no-padding no-margin"><strong>Folio:</strong> {{ detailFile.id }}</p>
              </div>
              <div class="col-md-5">
                <p class="no-padding no-margin"><strong>Cédula:</strong> {{ detailFile.cedula }}</p>
                <p class="no-padding no-margin"><strong>Fecha y hora:</strong> {{ detailFile.fecha_creacion }}</p>
                <p class="no-padding no-margin"><strong>Confianza de traducción:</strong> {{ detailFile.confidence | number:'1.2-2'}}%</p>
              </div>
              <div class="col-md-2">
                  <div class="p-relative text-center">
                    <div class="chart" >
                        <span  #peity [attr.data-peity]="detailFile.peity" data-peity="file.peity">{{ detailFile.peityPercentage }}</span>
        
                        <div class="pos-absolute a-0 d-flex flex-column align-items-center justify-content-center">
                          <h6 class="tx-rubik tx-spacing--1 mg-b-0">{{ detailFile.percentageFormat }}</h6>
                        </div>
                    </div>

                    <h6 class="tx-rubik tx-spacing--1 mg-b-0 mt-2">{{ detailFile.score }} / {{ detailFile.score_total}}</h6>
                  </div>
              </div>
            </div>
            
            <div class="row" >
              <div class="col">
                <div class="text-center mb-2 ">
                  <audio controls controlsList="nodownload" class="w-100 audio">
                    <source [src]="detailFile?.url_audio" [type]="detailFile?.mimetype">
                    Your browser does not support the audio element.
                  </audio>
                </div>
              </div>
            </div>
          </div>
  
          <div class="nav-wrapper mg-b-20 tx-13">
            <div>
              <nav class="nav nav-line tx-medium">
                <a href="#tabTranscription" class="nav-link active" data-toggle="tab">Transcripción</a>
                <a href="#tabAnalytics" class="nav-link" data-toggle="tab">Análisis</a>
                <a href="#tabEntities" class="nav-link" data-toggle="tab">Entidades</a>
                <a href="#tabKeyPhrases" class="nav-link" data-toggle="tab">Frases clave</a>
                <a href="#tabSentiments" class="nav-link" data-toggle="tab">Sentimientos</a>
              </nav>
            </div>
          </div><!-- nav-wrapper -->
  
          <div class="tab-content">
            <div id="tabTranscription" class="tab-pane fade active show">
              <div class="alert alert-warning" *ngIf="detailFile?.status_grabacion == 'PROCESANDO'">
                Procesando información, espere un momento ...
              </div>
              <div class="chat-content-body ps ps--active-y">
                <div class="chat-group ">
                  <ng-container *ngFor="let conversation of detailFile?.parser">
                    <div class="media">
                      <div class="media-body">
                        <h6>{{ convertSpeakerLabel(conversation.speaker_label) }}</h6>
                        <p class="mb-1">
                          <ng-container *ngFor="let info of conversation.content">
                            <label *ngIf="info.type != 'punctuation'" class="ml-1" data-toggle="tooltip"
                              data-placement="top" [title]="'Confianza: ' + confidenceFormat(info.confidence)  + '%'">
                              {{ info.content }}
                            </label>
                            <label *ngIf="info.type == 'punctuation'">{{ info.content }}</label>
                          </ng-container>
                        </p>
                      </div>
                    </div>
                    <hr>
                  </ng-container>
  
                </div>
  
              </div>
            </div>
            <div id="tabAnalytics" class="tab-pane fade">
  
              <div class="alert alert-warning" *ngIf="!detailFile?.analize_text || !detailFile?.analyze.length">
                Procesando información, espere un momento ...
              </div>
  
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Rúbrica</th>
                      <th scope="col">Fragmento</th>
                      <th scope="col">Puntaje</th>
                      <!-- <th scope="col">% Confianza</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of detailFile?.analyze">
                      <td width="30%">{{ item.punto_rubrica }}</td>
                      <td width="50%">{{ item.fragment }}</td>
                      <td>{{ item.found ? item.points: 0 }}/{{ item.points }}</td>
                      <!-- <td>{{ item.found + '%' }}</td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div id="tabEntities" class="tab-pane fade">
  
              <div class="alert alert-warning" *ngIf="!detailFile?.entities || !detailFile?.entities.Entities.length">
                Procesando información, espere un momento ...
              </div>
  
              <div class="table-responsive" *ngIf="detailFile?.entities">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Score</th>
                      <th scope="col">Tipo</th>
                      <th scope="col">Texto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of detailFile?.entities.Entities">
                      <td>{{ confidenceFormat(item.Score)  + '%' }}</td>
                      <td>{{ item.Type }}</td>
                      <td>{{ item.Text }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
  
            </div>
            <div id="tabKeyPhrases" class="tab-pane fade">
  
              <div class="alert alert-warning" *ngIf="!detailFile?.phrases || !detailFile?.phrases.KeyPhrases.length">
                Procesando información, espere un momento ...
              </div>
  
              <div class="table-responsive" *ngIf="detailFile?.phrases">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Score</th>
                      <th scope="col">Texto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of detailFile?.phrases.KeyPhrases">
                      <td>{{ confidenceFormat(item.Score)  + '%' }}</td>
                      <td>{{ item.Text }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div id="tabSentiments" class="tab-pane fade">
              <div class="alert alert-warning" *ngIf="!detailFile?.sentiments || !detailFile?.sentiments.length">
                Procesando información, espere un momento ...
              </div>
  
              <div class="table-responsive" *ngIf="detailFile?.sentiments">
  
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Tipo</th>
                      <th scope="col">Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of detailFile?.sentiments">
                      <td [class]="getClassSentiment(item.key)">{{ item.key }}</td>
                      <td [class]="getClassSentiment(item.key)">{{ confidenceFormat(item.value)  + '%' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
  
          </div><!-- tab-content -->
        </div><!-- modal-body -->
      </div><!-- modal-content -->
    </div><!-- modal-dialog -->
  </div><!-- modal -->